import React, { useState, useEffect } from "react";
import Header from "./Header";
import Footer from "./Footer";

function ContactPage() {

      // ✅ Set the page title (browser tab)
    useEffect(() => {
      document.title = "Contact | Prosep Services";
  
      let meta = document.querySelector('meta[name="description"]');
      if (!meta) {
        meta = document.createElement("meta");
        meta.name = "description";
        document.head.appendChild(meta);
      }
      meta.content = "We'd love to hear from you. Reach out and our team will get back to you as quickly as possible.";
  
      return () => {
        document.title = "Prosep Services";
      };
    }, []);
  const [form, setForm] = useState({
    name: "",
    email: "",
    phone: "",
    subject: "",
    message: "",
  });
  const [submitted, setSubmitted] = useState(false);

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log("Contact form submitted:", form);
    setSubmitted(true);
    setTimeout(() => setSubmitted(false), 4000);
    setForm({ name: "", email: "", phone: "", subject: "", message: "" });
  };

  return (
    <>
      <Header />

      <main className="contact-page">
        {/* ============ HERO ============ */}
        <section className="contact-hero">
          <div className="contact-hero-inner">
            <h1 className="contact-hero-title">
              Contact <span className="contact-hero-accent">Us.</span>
            </h1>
            <p className="contact-hero-subtitle">
              We'd love to hear from you. Reach out and our team will get back
              to you as quickly as possible.
            </p>
          </div>
        </section>

        {/* ============ MAIN: FORM + INFO ============ */}
        <section className="contact-section">
          <div className="contact-section-inner">
            {/* LEFT — Form */}
            <div className="contact-form-wrap">
              <h2 className="contact-heading">
                Get in touch using the form below
              </h2>

              <form className="contact-form" onSubmit={handleSubmit}>
                <div className="contact-row">
                  <div className="contact-field">
                    <label htmlFor="name">Full Name</label>
                    <input
                      id="name"
                      name="name"
                      type="text"
                      placeholder="Your full name"
                      value={form.name}
                      onChange={handleChange}
                      required
                    />
                  </div>

                  <div className="contact-field">
                    <label htmlFor="email">Email Address</label>
                    <input
                      id="email"
                      name="email"
                      type="email"
                      placeholder="you@example.com"
                      value={form.email}
                      onChange={handleChange}
                      required
                    />
                  </div>
                </div>

                <div className="contact-row">
                  <div className="contact-field">
                    <label htmlFor="phone">Phone Number</label>
                    <input
                      id="phone"
                      name="phone"
                      type="tel"
                      placeholder="+233 ..."
                      value={form.phone}
                      onChange={handleChange}
                    />
                  </div>

                  <div className="contact-field">
                    <label htmlFor="subject">Subject</label>
                    <input
                      id="subject"
                      name="subject"
                      type="text"
                      placeholder="What is this about?"
                      value={form.subject}
                      onChange={handleChange}
                    />
                  </div>
                </div>

                <div className="contact-field">
                  <label htmlFor="message">Message</label>
                  <textarea
                    id="message"
                    name="message"
                    rows="6"
                    placeholder="Tell us how we can help..."
                    value={form.message}
                    onChange={handleChange}
                    required
                  ></textarea>
                </div>

                <button type="submit" className="contact-submit">
                  Send Message
                  <span className="contact-arrow">→</span>
                </button>

                {submitted && (
                  <p className="contact-success">
                    ✓ Thank you — your message has been sent. We'll be in touch
                    soon.
                  </p>
                )}
              </form>
            </div>

            {/* RIGHT — Contact Info */}
            <aside className="contact-info-wrap">
              <h2 className="contact-heading">Contact Info</h2>

              <div className="contact-info-block">
                <div className="contact-info-icon">📞</div>
                <div>
                  <h3 className="contact-info-title">Tel</h3>
                  <ul className="contact-info-list">
                    <li><a href="tel:+233244235128">+233 (0) 244 235 128</a></li>
                    <li><a href="tel:+233302790300">+233 (0) 302 790 300</a></li>
                    <li><a href="tel:+233302403862">+233 (0) 302 403 862</a></li>
                  </ul>
                </div>
              </div>

              <div className="contact-info-block">
                <div className="contact-info-icon">✉️</div>
                <div>
                  <h3 className="contact-info-title">Email</h3>
                  <ul className="contact-info-list">
                    <li>
                      <a href="mailto:info@prosepservices.com">
                        info@prosepservices.com
                      </a>
                    </li>
                  </ul>
                </div>
              </div>

              <div className="contact-info-block">
                <div className="contact-info-icon">📍</div>
                <div>
                  <h3 className="contact-info-title">Office Location</h3>
                  <p className="contact-info-text">
                    Shalom Business Centre,
                    <br />
                    Golf Hills St, Achimota
                  </p>
                </div>
              </div>

              <div className="contact-info-block">
                <div className="contact-info-icon">🕒</div>
                <div>
                  <h3 className="contact-info-title">Working Hours</h3>
                  <p className="contact-info-text">
                    Mon – Fri: 8:00 AM – 5:00 PM
                    <br />
                    Sat: 9:00 AM – 2:00 PM
                  </p>
                </div>
              </div>
            </aside>
          </div>
        </section>

        {/* ============ MAP ============ */}
        <section className="contact-map">
          <iframe
            title="Prosep Services Location"
            src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d7941.2712677197105!2d-0.22760900000000003!3d5.620694!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0xfdf9b4d9ee038b5%3A0xeabcb219178ad156!2sProsep%20Services%20Limited!5e0!3m2!1sen!2sgh!4v1789356057760!5m2!1sen!2sgh"
            style={{ border: 0, width: "100%", height: "450px", display: "block" }}
            allowFullScreen
            loading="lazy"
            referrerPolicy="strict-origin-when-cross-origin"
          ></iframe>
        </section>
      </main>

      <Footer />

      <style>{`
        .contact-page {
          width: 100%;
          background: #ffffff;
          font-family: Arial, sans-serif;
        }

        /* ============ HERO ============ */
        .contact-hero {
          width: 100%;
          padding: 110px 40px 90px;
          background: linear-gradient(
            135deg,
            #001a3d 0%,
            #002a5c 50%,
            #0047a3 100%
          );
          text-align: center;
          box-sizing: border-box;
        }
        .contact-hero-inner {
          max-width: 900px;
          margin: 0 auto;
        }
        .contact-hero-title {
          font-size: 56px;
          font-weight: 900;
          color: #ffffff;
          margin: 0 0 20px;
          letter-spacing: 0.5px;
          line-height: 1.1;
        }
        .contact-hero-accent {
          color: #b8965a;
        }
        .contact-hero-subtitle {
          font-size: 19px;
          line-height: 1.6;
          color: #dbe5f0;
          margin: 0;
          max-width: 700px;
          margin-left: auto;
          margin-right: auto;
        }

        /* ============ MAIN ============ */
        .contact-section {
          width: 100%;
          padding: 90px 40px;
          box-sizing: border-box;
        }
        .contact-section-inner {
          max-width: 1400px;
          margin: 0 auto;
          display: grid;
          grid-template-columns: 1.4fr 1fr;
          gap: 60px;
          align-items: start;
        }

        .contact-heading {
          font-size: 26px;
          font-weight: 800;
          color: #111;
          margin: 0 0 28px;
          position: relative;
          padding-bottom: 14px;
        }
        .contact-heading::after {
          content: "";
          position: absolute;
          left: 0;
          bottom: 0;
          width: 48px;
          height: 3px;
          background: #c8102e;
        }

        /* ============ FORM ============ */
        .contact-form-wrap {
          background: #f7f9fc;
          border: 1px solid #e5e7eb;
          border-radius: 14px;
          padding: 40px;
        }

        .contact-form {
          display: flex;
          flex-direction: column;
          gap: 22px;
        }
        .contact-row {
          display: grid;
          grid-template-columns: 1fr 1fr;
          gap: 22px;
        }
        .contact-field {
          display: flex;
          flex-direction: column;
          gap: 8px;
        }
        .contact-field label {
          font-size: 14px;
          font-weight: 700;
          color: #111;
          letter-spacing: 0.3px;
        }
        .contact-field input,
        .contact-field textarea {
          width: 100%;
          padding: 14px 16px;
          border: 1px solid #d1d5db;
          border-radius: 8px;
          font-size: 15px;
          font-family: inherit;
          color: #111;
          background: #ffffff;
          outline: none;
          transition: border-color 0.15s ease, box-shadow 0.15s ease;
          box-sizing: border-box;
        }
        .contact-field input:focus,
        .contact-field textarea:focus {
          border-color: #c8102e;
          box-shadow: 0 0 0 3px rgba(200, 16, 46, 0.12);
        }
        .contact-field textarea {
          resize: vertical;
          min-height: 140px;
        }

        /* Submit */
        .contact-submit {
          display: inline-flex;
          align-items: center;
          justify-content: center;
          gap: 10px;
          padding: 16px 32px;
          background: #c8102e;
          color: #ffffff;
          border: none;
          border-radius: 999px;
          font-size: 15px;
          font-weight: 700;
          letter-spacing: 0.5px;
          cursor: pointer;
          transition: all 0.2s ease;
          font-family: inherit;
          align-self: flex-start;
          box-shadow: 0 6px 16px rgba(200, 16, 46, 0.28);
        }
        .contact-submit:hover {
          background: #a00d24;
          transform: translateY(-2px);
          box-shadow: 0 10px 24px rgba(200, 16, 46, 0.36);
        }
        .contact-arrow {
          display: inline-block;
          transition: transform 0.2s ease;
          font-size: 17px;
        }
        .contact-submit:hover .contact-arrow {
          transform: translateX(4px);
        }

        /* Success message */
        .contact-success {
          margin: 0;
          padding: 14px 18px;
          background: #ecfdf5;
          border: 1px solid #6ee7b7;
          color: #065f46;
          border-radius: 8px;
          font-size: 14px;
          font-weight: 600;
        }

        /* ============ INFO ============ */
        .contact-info-wrap {
          padding: 8px 0;
        }

        .contact-info-block {
          display: flex;
          gap: 16px;
          padding: 22px 0;
          border-bottom: 1px solid #e5e7eb;
        }
        .contact-info-block:last-child {
          border-bottom: none;
        }
        .contact-info-block:first-of-type {
          padding-top: 0;
        }

        .contact-info-icon {
          flex-shrink: 0;
          width: 48px;
          height: 48px;
          border-radius: 50%;
          background: #fef2f3;
          color: #c8102e;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 20px;
        }

        .contact-info-title {
          font-size: 15px;
          font-weight: 800;
          text-transform: uppercase;
          letter-spacing: 0.5px;
          color: #111;
          margin: 0 0 10px;
        }

        .contact-info-list {
          list-style: none;
          padding: 0;
          margin: 0;
          display: flex;
          flex-direction: column;
          gap: 8px;
        }
        .contact-info-list a {
          color: #4b5563;
          text-decoration: none;
          font-size: 15px;
          transition: color 0.15s ease;
        }
        .contact-info-list a:hover {
          color: #c8102e;
        }

        .contact-info-text {
          margin: 0;
          font-size: 15px;
          line-height: 1.7;
          color: #4b5563;
        }

        /* ============ MAP ============ */
        .contact-map {
          width: 100%;
          background: #f0f0f0;
        }
        .contact-map iframe {
          display: block;
          width: 100%;
          border: 0;
        }

        /* ============ RESPONSIVE ============ */
        @media (max-width: 1000px) {
          .contact-section-inner {
            grid-template-columns: 1fr;
            gap: 48px;
          }
          .contact-form-wrap {
            padding: 32px 24px;
          }
        }

        @media (max-width: 800px) {
          .contact-hero {
            padding: 80px 24px 70px;
          }
          .contact-hero-title {
            font-size: 42px;
          }
          .contact-hero-subtitle {
            font-size: 17px;
          }

          .contact-section {
            padding: 60px 24px;
          }
          .contact-heading {
            font-size: 22px;
          }
          .contact-row {
            grid-template-columns: 1fr;
            gap: 18px;
          }
        }

        @media (max-width: 500px) {
          .contact-hero {
            padding: 60px 20px 50px;
          }
          .contact-hero-title {
            font-size: 34px;
          }
          .contact-hero-subtitle {
            font-size: 15px;
          }
          .contact-section {
            padding: 40px 20px;
          }
          .contact-form-wrap {
            padding: 24px 18px;
          }
          .contact-submit {
            width: 100%;
            justify-content: center;
          }
          .contact-info-icon {
            width: 42px;
            height: 42px;
            font-size: 18px;
          }
        }
      `}</style>
    </>
  );
}

export default ContactPage;